import script from "./ConfigModalBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigModalBase.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigModalBase.vue?vue&type=style&index=0&id=2323b446&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2323b446"]])

export default __exports__